import { render, staticRenderFns } from "./TotalVaccinatedPanel.vue?vue&type=template&id=f779c854&"
import script from "./TotalVaccinatedPanel.vue?vue&type=script&lang=js&"
export * from "./TotalVaccinatedPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports